import { Grid, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import  '../../LegalDrafts/legal.css'

export default function Top_section_Legal(){
    return(
        <Grid container>
        <Grid container className="cont_top_OPC">
           <Container> 
        <Grid container>
            <Grid item sm={12} xs={12}>
                <Typography className="top_OPC_head">
                LEGAL DRAFTS
                </Typography>
            </Grid>

        </Grid>
        <Grid container style={{justifyContent:'center'}} >
            <Grid item>
                <Typography className="top_OPC_text">
                Serving corporates with best in mind
                </Typography>
            </Grid>
        </Grid>
        </Container>
        </Grid>
        </Grid>
    )
}